import React, {Component} from 'react'
import Button from '@material-ui/core/Button';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import DeleteArea from './DeleteArea'
import SecondStageOption from './SecondStageOption'
import LinkedList from '../../FunctionArea/LinkedList';

const wStyles = theme => ({
    textLink:{
        //height:30,
        width:"90%",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:12,
        margin:5,
        '&:hover':{
            color:"black",
            cursor:"pointer"
        }  
    }
})

class SecondStageOptionGroup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showWarningDialog:false,
            secondStageOptions:null,
            mousePos:{
                x:0,
                y:0
            },
            containerDragging:{
                status:false,
                sequence:null,
                conID:null
            },
            insertOption:{
                id:null,
                sequence:null
            },
            deleteOption:false
        }
        this.optionRef = React.createRef()
    }

    componentDidMount(){
        this.initialState()
    }

    componentDidUpdate(prevProps){
    }

    componentWillUnmount(){
    }

    initialState=()=>{
        if(this.props.optionInfo.list)
        {
            this.setState({
                secondStageOptions:this.returnLinkedList(this.props.optionInfo.list)
            })
        }
    }

    returnLinkedList =(list)=> {
        let cloneL = new LinkedList()
        
        if(list)
        {
            if(list.head)
            {
                let current = list.head
                while(current)
                {
                    let tempNodeData = {...current.data}
                    cloneL.insertLast(tempNodeData)
                    current = current.next
                }
            }
        }   
        return cloneL
    }

    createSecondStageOption=()=>{
        console.log("createSecondStageOption...")
        if(this.state.secondStageOptions){
            let tempLinkedList = this.state.secondStageOptions
            let tempArray = []
            let countI = -1
            for(let i=0;i< tempLinkedList.length;i++)
            {
                //console.log("i : ",i)
                //console.log(tempLinkedList.getAt(i))
                tempArray.push(tempLinkedList.getAt(i))
            }
            return tempArray.map(option=>{
                countI= countI+1
                return (<SecondStageOption key={option.id} mousePos={this.state.mousePos} optionInfo={option} sequence={countI} bgColor={option.color} containerDragging={this.containerDragging} otherDragging={this.state.containerDragging.conID} getHoverMsg={this.getHoverMsg} getTitleAndRoute={this.getTitleAndRoute} editPage={this.editPage} sessionAvaliable={this.props.sessionAvaliable}/>)
            })
        }
        else
        {
            return null
        }
    }

    onMouseMove=(e)=>{
        //console.log("ComponentLayot onMouseMove...")
        if(this.state.needMousePos)
        { 
            this.setState({
                mousePos:{
                    x:e.clientX,
                    y:e.clientY
                },
            })
        }
    }

    addNewSecond=()=>{
        console.log('addNewSecond...')
        let tempLinkedList
        if(this.state.secondStageOptions)
        {
            tempLinkedList = this.state.secondStageOptions.cloneList()
            let id = this.getSysID()
            let color = "#7ac0d8"
            let tempObj = {
                id:id,
                title:"請輸入第二階標題",
                route:"DefaultRoute",
                color:color,
            }
        
            tempLinkedList.insertLast(tempObj)
            console.log('tempLinkedList...')
            console.log(tempLinkedList)
        }
        else
        {
            tempLinkedList = new LinkedList()
            let id = this.getSysID()
            let color = "#7ac0d8"
            let tempObj = {
                id:id,
                title:"請輸入第二階標題",
                route:"DefaultRoute",
                color:color,
            }
        
            tempLinkedList.insertLast(tempObj)
            console.log('tempLinkedList...')
            console.log(tempLinkedList)

        }

        this.setState({
            secondStageOptions:tempLinkedList
        },()=>{
            let msg = {
                sequence:this.props.sequence,
                list:this.state.secondStageOptions
            }
            this.props.getSecondStageOptionList(msg)
        })
    }

    getID=()=>{
        if(this.state.secondStageOptions)
        {
            if(this.state.secondStageOptions.head)
            {
                let tempArray = this.state.secondStageOptions.transArray('id')
                console.log('id array : ')
                console.log(tempArray)
                let finalID = Math.max(...tempArray)+1
                return finalID
            }
            else
            {
                return 1
            }
        }
        else
        {
            return 1
        }
    }

    getSysID=()=>{
        let d = new Date()
        return d.getTime()+this.props.userID
    }

    containerDragging = (msg) => {
        //console.log('ControllerUnitLayout onContainerDragging')
        //console.log('conID : ',msg.conID, 'booling : ',msg.containerDragging)
        //console.log(msg.position)

        if(msg.containerDragging)
        {
            console.log('onContainerDragging A1')
            this.setState({
                secondStageOptions:this.updateTitleAndRoute(msg),
                containerDragging:{
                    status:msg.containerDragging,
                    sequence:msg.sequence,
                    conID:msg.conID
                },
                needMousePos:true,
            },()=>{
                let msg = {
                    sequence:this.props.sequence,
                    list:this.state.secondStageOptions
                }
                this.props.getSecondStageOptionList(msg)
            })            
        }
        else
        {   
            console.log('onContainerDragging A2')
            if(this.state.deleteOption)
            {
                let tempLinkedList = this.state.secondStageOptions.cloneList()
                tempLinkedList.removeAt(this.state.containerDragging.sequence)
                this.setState({
                    secondStageOptions:tempLinkedList,
                    deleteOption:false,
                    containerDragging:{
                        status:false,
                        sequence:null,
                        conID:null
                    },
                    needMousePos:false,
                    mousePos:{
                         x:0,
                        y:0
                    }
                },()=>{
                    let msg = {
                        sequence:this.props.sequence,
                        list:this.state.secondStageOptions
                    }
                    this.props.getSecondStageOptionList(msg)
                })
            }
            else
            {
                if(this.state.insertOption.id)
                {        
                    let changeInfo = {
                        insertToIndex:this.state.insertOption.sequence,
                        selectAtIndex:this.state.containerDragging.sequence,
                    }

                    this.setState({
                        containerDragging:{
                            status:false,
                            sequence:null,
                            conID:null
                        },
                        insertOption:{
                            id:null,
                            sequence:null
                        },
                        needMousePos:false,
                        mousePos:{
                            x:0,
                            y:0
                        }
                    },()=>{
                        this.reorderLinkedList(changeInfo)
                    })
                }
                else
                {
                    console.log('onContainerDragging A2-2-2')
                    this.setState({
                        containerDragging:{
                            status:false,
                            sequence:null,
                            conID:null
                        },
                        needMousePos:false,
                        mousePos:{
                            x:0,
                            y:0
                        }
                    })
                }
            }
        }
    }

    updateTitleAndRoute=(msg)=>{
        let tempLinkedList = this.state.secondStageOptions.cloneList()
        let tempObj = {
            id:msg.conID,
            title:msg.title,
            route:msg.route,
            color:msg.color,
        }

        tempLinkedList.removeAt(msg.sequence)
        tempLinkedList.insertAtPrefix(tempObj,msg.sequence)
        return tempLinkedList
    }

    getTitleAndRoute=(msg)=>{
        this.setState({
            secondStageOptions:this.updateTitleAndRoute(msg),
            containerDragging:{
                status:false,
                sequence:null,
                conID:null
            },
            needMousePos:false,
            insertOption:{
                id:null,
                sequence:null
            },
            deleteOption:false
        },()=>{
            let msg = {
                sequence:this.props.sequence,
                list:this.state.secondStageOptions
            }
            this.props.getSecondStageOptionList(msg)
        })
    }

    editPage=(msg)=>{
        this.props.editPage(msg)
    }

    reorderLinkedList=(changeInfo)=>{
        let tmpLinkedList = this.state.secondStageOptions.cloneList()
        if(changeInfo.insertToIndex === "last")
        {
            let targetIndex = tmpLinkedList.length-1
            tmpLinkedList.shiftToSurfix(changeInfo.selectAtIndex,targetIndex)
            console.log("tmpLinkedList")
            console.log(tmpLinkedList)
            this.setState({
                secondStageOptions:tmpLinkedList
            },()=>{
                let msg = {
                    sequence:this.props.sequence,
                    list:this.state.secondStageOptions
                }
                this.props.getSecondStageOptionList(msg)
            })
        }
        else
        {
            if(changeInfo.selectAtIndex<changeInfo.insertToIndex)
            {
                tmpLinkedList.shiftToPrefix(changeInfo.selectAtIndex,changeInfo.insertToIndex)
                console.log("tmpLinkedList")
                console.log(tmpLinkedList)
                this.setState({
                    secondStageOptions:tmpLinkedList
                },()=>{
                    let msg = {
                        sequence:this.props.sequence,
                        list:this.state.secondStageOptions
                    }
                    this.props.getSecondStageOptionList(msg)
                })
            }
            else
            {
                tmpLinkedList.shiftToPrefix(changeInfo.selectAtIndex,changeInfo.insertToIndex)
                console.log("tmpLinkedList")
                console.log(tmpLinkedList)
                this.setState({
                    secondStageOptions:tmpLinkedList
                },()=>{
                    let msg = {
                        sequence:this.props.sequence,
                        list:this.state.secondStageOptions
                    }
                    this.props.getSecondStageOptionList(msg)
                })
            }
        }
    }

    getHoverMsg = (msg) => {
        console.log("getOption...")
        console.log(msg)
        if(msg.status)
        {
            if(msg.id !== this.state.insertOption.id)
            {
                this.setState({
                    insertOption:msg
                })
            }
        }
        else
        {
            if(this.state.insertOption.id)
            {
                this.setState({
                    insertOption:{
                        id:null,
                        sequence:null
                    }
                })
            }
        }
    }

    getDeleteSequence=(msg)=>{
        if(this.state.deleteOption !== msg)
        {
            this.setState({
                deleteOption:msg
            })
        }
    }

    render(){
        const {classes} = this.props;
        let secondStageOptionGroupStyle = {
            //width:"700px",
            //margin:"5px",
            fontFamily:"Microsoft JhengHei",
            borderStyle:"soild",
            borderWidth:1,
            borderColor:"black",
            textAlign:"center",
            fontSize:15,
            lineHeight:"30px",
            backgroundColor:this.props.bgColor,
            color:"white",
            margin:"10px"
        }

        let labelArea = {
            width:"30%",
            //height:"40px",        
        }

        let secondStageContainerStyle = {
            display:"flex",
            height:"80%",
            flexDirection:"column",
            alignItems:"center",
            marginTop:"5px"
            //overflow:"overlay"
        }

        let tempProps = {
            id:99,
            title:"bufferArea",
            route:"bufferArea",
        }

        let rowContainerStyle = {
            width:"70%"
        }

        return(
            <div style={secondStageOptionGroupStyle} onMouseMove={this.onMouseMove} ref={this.optionRef} > 
                <div style={{display:"flex"}}>
                    <div style={labelArea}>
                        {this.props.optionInfo.title}{" "}<span style={{color:"#d6d6d6"}}>{this.props.optionInfo.route}</span>
                        <Button className={classes.textLink} startIcon={<AddBoxIcon/>} onClick={this.addNewSecond}>
                            {'新增第二階選項'}
                        </Button>
                        <DeleteArea mousePos={this.state.mousePos} otherDragging={this.state.containerDragging.conID} detectDirection={"x"} areaHeight={null} fontSize={12} getDeleteSequence={this.getDeleteSequence}/>
                    </div>
                    <div style={rowContainerStyle}>               
                        <div style={secondStageContainerStyle}>
                            {this.createSecondStageOption()}
                            <SecondStageOption key={tempProps.id} mousePos={this.state.mousePos} optionInfo={tempProps} sequence={"last"} bgColor={null} containerDragging={this.containerDragging} otherDragging={this.state.containerDragging.conID} getHoverMsg={this.getHoverMsg} getTitleAndRoute={this.getTitleAndRoute} />
                        </div>
                    </div>
                </div>         
            </div>
        )
    }
}

export default withStyles(wStyles)(SecondStageOptionGroup)